export default "__VITE_ASSET__B6eY2vaM__"